import './App.css';

function App({ content }) {
  return (
    <div className="App">
      <header className="App-header">
        {content}
      </header>
    </div>
  );
}
export default App;